import CoordGeoFormController from './coord.geo.form.controller';
import Template from './coord.geo.form.html';

export default {
	bindings: {
		isReadOnly: '=',
		isDisabled: '=',
		autoUpdateMap: '=',
		coordGeo: '=',
		adresse: '=',
		codePostal: '=',
		ville: '=',
		onChange: '&'
	},
	template: Template,
	controller: CoordGeoFormController
};
